
import XButton from 'vux/src/components/x-button/index.vue'

import { mapState, mapActions } from "vuex";
import GuideCover from "@/components/guideCover.vue";
import { sharePageData } from "@/api/ajax.js";
export default {
name: "share",
data() {
return {
btList: ["获奖记录", "提现记录"],
btIndex: 0,
recordList: [],
getMoney: 0,
hasMore: true,
};
},
methods: {
toHome() {
sa.track(
"activity",
{
action: "vzb_dati2018",
type: "share_to_start",
},
function () {}
);

this.$sa.re_activity({
name: "答题拼图",
event_type: "点击去首页",
});

this.$router.push({
name: "home",
});
},
toast() {
this.$vux.toast.show({
text: "点击右上角，分享给微信好友吧",
type: "text",
width: "7rem",
});
},
tabClick(item, index) {
this.btIndex = index;
},
ATM(item, index) {
this.change(true);
sa.track(
"activity",
{
action: "vzb_dati2018",
type: "red_pocket",
},
function () {}
);

this.$sa.re_activity({
name: "答题拼图",
event_type: "点击赶紧拆",
});

sharePageData
.unPackRedPack({
redPackId: this.$route.params.redPackId,
wxOpenId: this.wxUserInfo.wxOpenId,
nickName: this.wxUserInfo.nickName,
headPhoto: this.wxUserInfo.headPhoto,
})
.then((res) => {
this.getData(false); 
let message = res.data.message;
let code = res.data.code;
if (code == 1) {

this.getMoney = res.data.redPack;
this.showCoverAction({
show: true,
type: 7,
});



} else if (code == 102) {

this.showCoverAction({
show: true,
type: 6,
});
} else if (code == 104) {

this.showCoverAction({
show: true,
type: 5,
});
} else {
this.$vux.toast.show({
text: message,
type: "text",
width: "7rem",
});
}
this.change(false);
});
},
getData(isFirst) {
sharePageData
.sharePageData({
redPackId: this.$route.params.redPackId,
shareUserId: "",
})
.then((res) => {
if (res.data.status == "1") {
this.recordList = res.data.data;
if (this.recordList[1].nickName && this.recordList[2].nickName) {
this.hasMore = false;
}
if (isFirst) {
let shareUrl = `${this.$config.javaPath}/html/answerGold/index210505.html#/share/${this.$route.params.redPackId}?shareFlag=true`;
this.$wxShareInfo(
"你领或不领，红包就在那里，不离不弃~",
"但手速慢，被别人抢，可不能怪我没提醒",
"http://cdn.yxvzb.com/html/AnswerGold/share2.png",
location.href.split("#")[0],
shareUrl,
""
);
}
} else {
this.$vux.toast.show({
text: res.data.message,
type: "text",
width: "7rem",
});

this.$router.push({
name: "home",
});
}
});
},
...mapActions(["showCoverAction", "change"]),
},
computed: {
...mapState({
wxUserInfo: (state) => state.wxUserInfo,
}),
},
components: {
XButton,
GuideCover,
},
created() {
this.getData("first");
},
};



// WEBPACK FOOTER //
// ./src/page/Share/index.vue